import confetti, { Options as ConfettiOptions } from 'canvas-confetti'

/**
 * One simple confetti effect.
 */
export const confetti1 = () => {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
  })
}

/**
 * Another confetti effect just a little broader.
 */
export const confetti2 = () => {
  const count = 200
  const defaults = {
    origin: { y: 0.7 },
  }

  const fire = (particleRatio: number, opts: ConfettiOptions) => {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio),
    })
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  })
  fire(0.2, {
    spread: 60,
  })
  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  })
  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  })
  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  })
}

/**
 * Confetti fireworks
 * It takes several seconds.
 */
export const confetti3 = () => {
  const duration = 12 * 1000
  const animationEnd = Date.now() + duration
  const defaults = {
    particleCount: 120,
    startVelocity: 30,
    spread: 160,
    ticks: 60,
    scalar: 1.4,
    zIndex: 0,
    colors: ['#ffc22a', '#3b3a6d', '#ffe4c9'],
  }

  const randomInRange = (min: number, max: number) => {
    return Math.random() * (max - min) + min
  }

  const interval = setInterval(() => {
    const timeLeft = animationEnd - Date.now()

    if (timeLeft <= 0) {
      return clearInterval(interval)
    }

    const particleCount = 50 * (timeLeft / duration)
    // since particles fall down, start a bit higher than random
    confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } })
    confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } })
  }, 250)
}
